import { segundosAteTerminoPromocao } from '@core/utils/utils';

export default {
  namespaced: true,
  state: () => ({
    picSelected: {
      picid: null,
      picdescricao: null,
    },
    picSelectedOperacao: {
      picid: null,
      picdescricao: null,
    },
    pic: {
      pic_genericas: [],
      pic_cliente: [],
    },
    filters: {
      estabelecimentoid: null,
      condicaopagamentoid: null,
      clienteid: null,
      tabelaprecoId: null,
    },
    loading: false,
    infoPedidoPic: [],
    operacaoPedidoPic: [],
  }),
  mutations: {
    RESET_PIC_SELECTION(state) {
      state.picSelected = null;
      state.pics = [];
    },
    SET_PIC(state, pic) {
      state.pic = pic;
    },
    SET_PIC_GENERICAS(state, pic) {
      state.pic.pic_genericas = pic;
    },
    SET_PIC_CLIENTE(state, pic) {
      state.pic.pic_cliente = pic;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    SET_FILTERS_ESTABELECIMENTOID(state, estabelecimentoid) {
      state.filters.estabelecimentoid = estabelecimentoid;
    },
    SET_FILTERS_CONDICAOPAGAMENTO_ID(state, condicaopagamentoid) {
      state.filters.condicaopagamentoid = condicaopagamentoid;
    },
    SET_FILTERS_CLIENTEID(state, clienteId) {
      state.filters.clienteId = clienteId;
    },
    SET_FILTERS_TABELAPRECO_ID(state, tabelaprecoId) {
      state.filters.tabelaprecoId = tabelaprecoId;
    },
    SET_INFO_PEDIDO_PIC(state, infoPedidoPic) {
      state.infoPedidoPic = infoPedidoPic;
    },
    SET_OPERACAO_PEDIDO_PIC(state, operacaoPedidoPic) {
      state.operacaoPedidoPic = operacaoPedidoPic;
    },
    ADD_UPDATE_ITEMS_PIC_INFO_PEDIDO(state, items) {
      state.infoPedidoPic = state.infoPedidoPic.map((info) => {
        if (info.itemid === items.itemid) {
          return {
            ...info,
            ItemsPic: items.ItemsPic,
          };
        }
        return info;
      });
    },
    UPDATE_CHECKED_ITEM_PIC_SELECTED_INFO_PEDIDO(state, { itemid, checked }) {
      if ((!state.picSelected && !state.picSelected.ItemsPic.length) && (!state.picSelectedOperacao && !state.picSelectedOperacao.ItemsPic.length)) return;
      state.picSelected.ItemsPic = state.picSelected.ItemsPic.map((item) => {
        if (item.itemid === itemid) {
          return {
            ...item,
            checked,
          };
        }
        return item;
      });
    },
    UPDATE_CHECKED_ITEM_PIC_SELECTED_OPERACAO_PEDIDO(state, { itemid, checked }) {
      if (!state.picSelectedOperacao.ItemsPic.length) return;
      state.picSelectedOperacao.ItemsPic = state.picSelectedOperacao.ItemsPic.map((item) => {
        if (item.itemid === itemid) {
          return {
            ...item,
            checked,
          };
        }
        return item;
      });
    },
    ADD_UPDATE_ITEMS_PIC_OPERACAO_PEDIDO(state, items) {
      state.operacaoPedidoPic = state.operacaoPedidoPic.map((info) => {
        if (info.itemid === items.itemid) {
          return {
            ...info,
            ItemsPic: items.ItemsPic,
          };
        }
        return info;
      });
    },
    REMOVER_ITEM_PIC_INFO_PEDIDO(state, { picid, itemid }) {
      state.infoPedidoPic = state.infoPedidoPic.map((info) => {
        if (info.itemid === itemid) {
          return {
            ...info,
            ItemsPic: info.ItemsPic.filter((item) => item.itemid !== itemid),
          };
        }
        return info;
      });
    },
    REMOVER_ITEM_PIC_OPERACAO_PEDIDO(state, { picid, itemid }) {
      state.operacaoPedidoPic = state.operacaoPedidoPic.map((info) => {
        if (info.itemid === itemid) {
          return {
            ...info,
            ItemsPic: info.ItemsPic.filter((item) => item.itemid !== itemid),
          };
        }
        return info;
      });
    },
    ADD_UPDATE_INFO_PEDIDO_PIC(state, infoPedidoPic) {
      const index = state.infoPedidoPic.findIndex((info) => info.picid === infoPedidoPic.picid);
      if (index === -1) {
        state.infoPedidoPic.push(infoPedidoPic);
      } else {
        state.infoPedidoPic[index] = infoPedidoPic;
      }
    },
    ADD_UPDATE_OPERACAO_PEDIDO_PIC(state, operacaoPedidoPic) {
      const index = state.operacaoPedidoPic.findIndex((info) => info.picid === operacaoPedidoPic.picid);
      if (index === -1) {
        state.operacaoPedidoPic.push(operacaoPedidoPic);
      } else {
        state.operacaoPedidoPic[index] = operacaoPedidoPic;
      }
    },
    REMOVER_EXITENTE_INFO_PEDIDO_PIC(state, picid) {
      state.infoPedidoPic = state.infoPedidoPic.filter((info) => info.picid !== picid);
    },
    REMOVER_EXITENTE_OPERACAO_PEDIDO_PIC(state, picid) {
      state.operacaoPedidoPic = state.operacaoPedidoPic.filter((info) => info.picid !== picid);
    },
    SET_CHECKED_PICK_OPERACAO_PEDIDO(state, { picid, checked, type }) {
      if (checked === false) {
        state.picSelectedOperacao = {
          picid: null,
          picdescricao: null,
        };
      }
      const unchedked = state.pic[type].filter((info) => info.picid !== picid);
      for (const info of unchedked) {
        const findUncheck = state.pic[type].find((info) => info.picid === picid);
        if (findUncheck) {
          document.querySelector(`#check-pic-${info.picid}`).checked = false;
          findUncheck.checked = false;
        }
        if (info.ItemsPic.length > 0) {
          info.ItemsPic.forEach((item) => {
            document.querySelector(`#check-item-${item.itemid}-${item.picid}`).checked = false;
          });
        }
      }
      const findPic = state.pic[type].find((info) => info.picid === picid);
      if (findPic) {
        state.picSelectedOperacao = findPic;
        findPic.checked = checked;
        document.querySelector(`#check-item-${findPic.ItemsPic[0].itemid}-${findPic.ItemsPic[0].picid}`).checked = checked;
      }
    },
    SET_CHECKED_PICK_INFO_PEDIDO(state, { picid, checked, type }) {
      if (checked === false) {
        state.picSelected = null;
      }
      const unchedked = state.pic[type].filter((info) => info.picid !== picid);
      for (const info of unchedked) {
        const findUncheck = state.pic[type].find((info) => info.picid === picid);
        if (findUncheck) {
          document.querySelector(`#check-pic-${info.picid}`).checked = false;
          findUncheck.checked = false;
        }
        if (info.ItemsPic.length > 0) {
          info.ItemsPic.forEach((item) => {
            document.querySelector(`#check-item-${item.itemid}-${item.picid}`).checked = false;
          });
        }
      }
      const findPic = state.pic[type].find((info) => info.picid === picid);
      if (findPic) {
        state.picSelected = findPic;
        findPic.checked = checked;
        document.querySelector(`#check-item-${findPic.ItemsPic[0].itemid}-${findPic.ItemsPic[0].picid}`).checked = checked;
      }
    },
    SET_PIC_SELECTED(state, picSelected) {
      state.picSelected = picSelected;
    },
  },
  getters: {
    GET_PIC: (state) => state.pic,
    GET_PIC_GENERICAS: (state) => {
      const allItemsGenerics = [];

      if (state.pic.pic_genericas.length > 0) {
        state.pic.pic_genericas.forEach((pic) => {
          pic.ItemsPic.forEach((item) => {
            allItemsGenerics.push({
              ...item,
              secondTime: segundosAteTerminoPromocao(pic.picterminovalidade, pic.picterminovalidadehora),
            });
          });
        });
      }

      //
      // const picAlterada = state.pic.pic_genericas.map(pic => {
      //     pic.ItemsPic.forEach(item => {
      //         return {
      //             ...item,
      //             secondTime: segundosAteTerminoPromocao(pic.picterminovalidade, pic.picterminovalidadehora)
      //         }
      //     })
      // })
      // console.log(picAlterada.map(item => ({ time: item.secondTime, item: item.itemid })))
      return allItemsGenerics;
    },
    GET_PIC_CLIENTE: (state) => state.pic.pic_cliente,
    GET_LOADING: (state) => state.loading,
    GET_FILTERS: (state) => state.filters,
    IS_EXIST_PIC: (state) => state.pic.pic_genericas.length > 0 || state.pic.pic_cliente.length > 0,
    GET_INFO_PEDIDO_PIC: (state) => state.infoPedidoPic.map((pic) => ({
      ...pic,
      checked: false,
    })),
    GET_OPERACAO_PEDIDO_PIC: (state) => state.operacaoPedidoPic,
    GET_PIC_CHECKED: (state) => type => state.pic[type].find((info) => info.checked),
    GET_PIC_SELECTED: (state) => state.picSelected,
    GET_PIC_SELECTED_OPERACAO: (state) => state.picSelectedOperacao,
  },
  actions: {
    async checkedPicSelected({ state }) {
      if (state.picSelected.picid) {
        document.querySelector(`#check-pic-${state.picSelected.picid}`).checked = true;
        state.picSelected.ItemsPic.forEach((item) => {
          if (item.checked) {
            document.querySelector(`#check-item-${item.itemid}-${item.picid}`).checked = true;
          }
        });
      }
    },
    async checkedPicSelectedOperacao({ state }) {
      if (state.picSelectedOperacao.picid) {
        document.querySelector(`#check-pic-${state.picSelectedOperacao.picid}`).checked = true;
        state.picSelectedOperacao.ItemsPic.forEach((item) => {
          if (item.checked) {
            document.querySelector(`#check-item-${item.itemid}-${item.picid}`).checked = true;
          }
        });
      }
    },
  },
};
